import { type FC } from 'react';

import { type Chapter } from '@editor2/types/chapter';
import { type PageGroup } from '@editor2/types/pageGroup';
import { type Page } from '@editor2/types/page';
import { header, breadcrumbs, options, indent } from './styles';
import { useSelector } from 'react-redux';
import { type RootState } from '@editor2/reducers/root';
import BreadcrumbItem from './BreadcrumbItem';
import { type Course } from '@editor2/types/course';
import { API_HOST } from '@editor2/constants/api';

interface Props {
	course: Course;
	chapter?: Chapter;
	pageGroup?: PageGroup;
	page?: Page;
}

const BASE_URL = API_HOST;

const Header: FC<Props> = (props) => {
	const { course, chapter, pageGroup, page } = props;

	const { canUpdateResource } = useSelector(
		(state: RootState) => state.courses[course.id].policies
	);

	const webtextViewUrl =
		`${BASE_URL}/courses/${course.id}` +
		(chapter ? `/traditional_book/chapters/${chapter.id}` : '') +
		(page ? `/pages/${page.id}` : '');

	const xmlUrl =
		`${BASE_URL}/editor2/courses/${course.id}` +
		(chapter ? `/chapters/${chapter.id}` : '') +
		(pageGroup && !page ? `/page_groups/${pageGroup.id}` : '') +
		(page ? `/pages/${page.id}` : '') +
		`.xml`;

	return (
		<div className={`${header} ${canUpdateResource ? '' : indent}`}>
			<div className="courseInfo">
				<div className={breadcrumbs}>
					{!chapter && <div>{course.name}</div>}

					{chapter && <BreadcrumbItem course={course} />}

					{pageGroup && <BreadcrumbItem course={course} chapter={chapter} />}

					{page && <BreadcrumbItem course={course} chapter={chapter} pageGroup={pageGroup} />}
				</div>
			</div>

			<div className={options}>
				<a href={webtextViewUrl} rel="noreferrer" className="webtextView">
					Webtext View
				</a>
				<a href={xmlUrl} target="_blank" rel="noreferrer">
					XML
				</a>
			</div>
		</div>
	);
};

export default Header;
